import React from 'react'
import SuggestContentList from './SuggestContentList'
import { isEmpty } from '../../utils/lang'

const SuggestServiceContent = ({ suggestionsService, idxStartAt, selectedId, updateSelectedId, onClick }) => {
  if (isEmpty(suggestionsService)) return <></>
  return (
    <SuggestContentList
      suggestions={suggestionsService}
      idxStartAt={idxStartAt}
      onClick={onClick}
      selectedId={selectedId}
      updateSelectedId={updateSelectedId}
    />
  )
}
export default SuggestServiceContent
